import React, { useContext, useState } from "react";
import { FaRegUser } from "react-icons/fa";
import { MdNotificationsNone } from "react-icons/md";
import { MdLockOutline } from "react-icons/md";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import ClickOutside from "../../components/ClickOutside";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import AvatarInitials from "../../components/AvatarInitials";
import { KYCStatusBadge } from "../../helpers/constants";
import { GrCompliance } from "react-icons/gr";
import { BusinessContext } from "../../context/BusinessContext";

const UserDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { user } = useSelector((state) => state.auth);

  const { setActiveBusiness } = useContext(BusinessContext);

  return (
    <ClickOutside onClick={() => setDropdownOpen(false)} className="relative">
      <div>
        <AvatarInitials
          firstName={user?.firstname}
          lastName={user?.lastname}
          className={
            "w-10 h-10 md:w-12 md:h-12 cursor-pointer text-lg sm:text-xl"
          }
          onClick={() => setDropdownOpen(!dropdownOpen)}
        />

        {dropdownOpen && (
          <div
            className={`absolute right-0 mt-2 pb-2 w-[18rem] rounded-lg bg-white shadow-md border border-stroke`}
          >
            <div className="h-[5.5rem] bg-primary rounded-t-lg"></div>

            <AvatarInitials
              firstName={user?.firstname}
              lastName={user?.lastname}
              className={
                "relative top-[-2.3rem] w-20 h-20 border border-primary bg-[lightgray] text-primary mx-auto text-2xl sm:text-3xl"
              }
            />

            <div className="mt-[-1.3rem] text-lg text-center space-y-0.5">
              <p className="font-semibold capitalize">
                {user?.firstname} {user?.middlename} {user?.lastname}
              </p>
              <p className="text-center tracking-wide text-base">
                {user?.email}
              </p>
            </div>

            <div className="flex justify-center gap-2 my-5">
              <p className="flex items-center gap-1 text-[0.9rem]">
                <GrCompliance className="text-xs" />
                Compliance:
              </p>
              <KYCStatusBadge status={user?.kycStatus || "pending"} />
            </div>

            <hr className="my-2 text-stroke" />
            <button
              onClick={() => {
                navigate("/profile");
                setDropdownOpen(false);
              }}
              className="flex items-center gap-1.5 w-full py-2 mt-1 hover:bg-[lightgray] px-2.5 text-sm"
            >
              <FaRegUser className="text-lg" /> <span>Your Profile</span>
            </button>
            <button
              onClick={() => navigate("#")}
              className="flex items-center gap-1.5 w-full py-2 my-1 hover:bg-[lightgray] px-2.5 text-sm"
            >
              <MdNotificationsNone className="text-[1.4rem]" />{" "}
              <span>Notifications</span>
            </button>

            <button
              onClick={() => navigate("#")}
              className="flex items-center gap-1.5 w-full py-2 my-1 hover:bg-[lightgray] px-2.5 text-sm"
            >
              <MdLockOutline className="text-[1.4rem]" />
              <span>Lock screen</span>
            </button>
            <hr className="my-2 text-stroke" />
            <button
              onClick={() => {
                navigate("/");
                dispatch(logout());
                setActiveBusiness(null)
              }}
              className="flex items-center gap-1.5 w-full py-2 hover:bg-red-100 px-2.5 text-[#f02d34]"
            >
              <RiLogoutCircleRLine className="text-[1.55rem] font-light" />{" "}
              <span>Logout</span>
            </button>
          </div>
        )}
      </div>
    </ClickOutside>
  );
};

export default UserDropdown;
